import { ReactNode } from 'react';
import styled from 'styled-components';
import { fontSizeDefinitions_DEPRECATED } from '../../atomicComponents/fonts/fontSizeDefinitionsWithDefaultFont';
import { horizontalSpacing } from 'tabview/pagesView/constants';
import {
  DescriptionFormat,
  printableTextStyles,
} from 'tabview/pagesView/commonUIElements';
import { colors } from '@ardoq/design-tokens';
import { BULK_POPOVER_ATTR } from '@ardoq/popovers';
import { unescapeHTML } from '@ardoq/html';
interface FieldProps {
  fieldId: string;
  text: string;
  description: string;
}

const LabelContainer = styled.div`
  ${fontSizeDefinitions_DEPRECATED.MEDIUM}
  color: ${colors.grey950};
  width: 30%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: ${horizontalSpacing.SMALL};
  font-weight: bold;
  ${printableTextStyles}
`;

const Label = styled.div`
  max-width: 400px;
`;

export const resolveFieldPopover = (
  element: HTMLElement | SVGElement
): ReactNode | null => {
  if (!(element instanceof HTMLElement)) return null;
  if (element.getAttribute('data-label') === null) return null;
  const containerEl = element.parentElement!;
  const labelIsOverflowing = element.offsetWidth > containerEl.offsetWidth;
  const { label, description } = element.dataset;
  return labelIsOverflowing || description?.length ? (
    <>
      {labelIsOverflowing && <Label>{label}</Label>}
      {description?.length ? (
        <DescriptionFormat>{unescapeHTML(description)}</DescriptionFormat>
      ) : (
        ''
      )}
    </>
  ) : null;
};

const withFieldPopover = (label: string, description: string) => ({
  [BULK_POPOVER_ATTR]: 'true',
  'data-label': label,
  'data-description': description,
});

const FieldLabel = ({ fieldId, text, description }: FieldProps) => (
  <LabelContainer key={fieldId}>
    <span {...withFieldPopover(text, description)}>{text}</span>
  </LabelContainer>
);

export { FieldLabel };
